import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { NewVersionCheckerService, ThemeService } from '@iw/core/services';

import { ViewportService } from './core/services/viewport.service';
import { PwaSetupDialog } from './features/pwa-setup';

@Component({
  selector: 'iw-root',
  imports: [TranslateModule, RouterOutlet, IconModule],
  template: ` @defer {
    @if (!isOldIos) {
      <router-outlet />

      <!-- Landscape overlay -->
      <div
        class="landscape-warning"
        [class.landscape-warning--visible]="isLandscape()"
      >
        <div>
          <fu-icon iconName="mobile-cancel" size="96" />
          <h2>{{ 'landscapeLock.title' | translate }}</h2>
          <p>
            {{ 'landscapeLock.subtitle-1' | translate }}
            <br />
            {{ 'landscapeLock.subtitle-2' | translate }}
          </p>
        </div>
      </div>
    } @else {
      <p>Some features may not work as expected. Please update your device.</p>
    }
  }`,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  readonly #themeService = inject(ThemeService);
  readonly #pwaSetupDialog = inject(PwaSetupDialog);
  readonly #viewportService = inject(ViewportService);
  readonly #newVersionCheckerService = inject(NewVersionCheckerService);

  isOldIos = this.#pwaSetupDialog.checkOldIos();

  isLandscape = this.#viewportService.isLandscape;

  ngOnInit() {
    this.#viewportService.applyViewportForPlatform();
    this.#viewportService.applyOrientationLock();
    this.#pwaSetupDialog.init();
  }

  ngOnDestroy() {
    this.#viewportService.destroyOrientationLock();
  }
}
